import { useEffect, useState } from 'react';
import { FieldProps } from '@rjsf/core';
import { useDownload, useUpload } from 'hooks';

export const useUploadFile = (props: FieldProps<number>)  => {
   
    const [docId, setDocId] = useState<number | null>(props.formData)
    const [docName, setDocName] = useState<string>()
    const { accept } = (props.uiSchema['ui:options'] || {}) as Record<string, any>
    const [base64, setBase64] = useState<string>()
    const {download} = useDownload()
    const { progress, setProgress, upload } = useUpload()
    const [errorMessage, setErrorMessage] = useState<string>()
    
    useEffect(() => {
        setDocId((v) => {
            if (props.formData !== v) return props.formData
            return v
        })
    }, [props.formData])

    useEffect(() => {
        accept === 'img' && getBase64()
    }, [docId])

    const getBase64 = async () => {
        setBase64('')
        const blob = await download(docId as number) as Blob
        if(blob) {
            const buffer = Buffer.from(await blob.arrayBuffer())
            setBase64(buffer.toString('base64'))
            setDocName('logo')
        }
        
    }

    const handleUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;
        try {
            const response = await upload(file)
            setDocId(response.docId)
            setDocName(response.docFilename)
            setErrorMessage('')
            props.onChange(response.docId)
        } catch (error: any) {
            if (error.message === 'FILE_TOO_LARGE') {
                const limit = parseInt(process.env.REACT_APP_LOGIN_UPLOAD_LIMIT as string)
                setErrorMessage(`Le fichier ne doit pas dépasser les ${(limit / 1000)}ko`)
            } else {
                setErrorMessage(`Il y a eu une erreur lors de l'upload`)
            }
        }
    };

    const handleRemoveFile = () => {
        setProgress(0)
        setDocId(null)
        props.onChange(undefined)
    }

    return {
        docId,
        progress,
        docName,
        accept,
        base64,
        errorMessage,
        handleUpload,
        handleRemoveFile
    }
}
